import {
	faCheck,
	faExclamationCircle,
	faExclamationTriangle,
	faInfoCircle,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import styled, { css } from 'styled-components'

import { Modal } from '@/components'
import { useAppContext } from '@/hooks'

import Button from '../Button/Button'

type MessageModalType = 'info' | 'warn' | 'error'

type Props = {
	message: string | React.ReactNode
	onClose?: () => void
	opened?: boolean
	stickyFooter?: boolean
	title: string
	type: MessageModalType
	width?: number | string
}

const typeToIcon = {
	info: faInfoCircle,
	warn: faExclamationTriangle,
	error: faExclamationCircle,
	success: faCheck,
} as const

export const MessageModal = ({
	title,
	type,
	message,
	width,
	opened,
	onClose,
	stickyFooter,
}: Props) => {
	const { t } = useAppContext()
	const [open, setOpen] = useState(true)
	const handleClose = () => setOpen(false)

	return (
		<Modal
			header={
				<Header type={type} data-testid="message-modal-header">
					<FontAwesomeIcon icon={typeToIcon[type]} data-testid="message-modal-icon" />
					<span data-testid="message-modal-title">{title}</span>
				</Header>
			}
			headerStyle={{ padding: 0, border: '0' }}
			footer={
				<Button onClick={onClose ?? handleClose} schema="primary" name="message-modal-ok">
					{t('OK')}
				</Button>
			}
			open={opened ?? open}
			onClose={onClose ?? handleClose}
			contentStyle={{ width: width ?? 400, border: '0' }}
			stickyFooter={stickyFooter}
			data-testid={`message-modal-${type}`}
		>
			{message}
		</Modal>
	)
}

const Header = styled.div<{ type: MessageModalType }>`
	font-size: 14px;
	text-align: left;
	display: flex;
	align-items: center;
	padding: 20px;
	${(props) => css`
		background: ${props.theme.colors.message[props.type].background};
		color: ${props.theme.colors.message[props.type].color};
	`}

	> span {
		margin-left: 10px;
	}
`
